import { Button } from '@winnin/winnin_ui.components.button'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Title } from '@winnin/winnin_ui.components.title'

import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { translations } from './rename-niches-form.i18n'
import type { TRenameNichesFormView } from './rename-niches-form.types'
import './rename-niches-form.styles.scss'
import { ConfirmNicheAction } from '../confirm-niche-action'

export const RenameNichesFormView = ({
  nicheList,
  handleChange,
  nichesToRename,
  handleCancel,
  handleSubmit,
  isSubmitButtonDisabled,
  handleViewConfirmation,
  isConfirmView,
  isMutationLoading,
}: TRenameNichesFormView) => {
  if (isConfirmView) {
    return (
      <ConfirmNicheAction
        handleClose={handleCancel}
        handleConfirm={handleSubmit}
        isButtonDisabled={isMutationLoading}
      />
    )
  }

  return (
    <div className="RenameNichesForm">
      <Title tag="h2">
        <T keyName={translations.title.key}>{translations.title.defaultValue}</T>
      </Title>
      <ul className="RenameNichesForm-nicheList">
        {nicheList.map(item => {
          const territoryId = item.id
          const nameFromState = nichesToRename?.[territoryId]
          return (
            <li key={territoryId}>
              <InputWithLabel
                label={item.name}
                name={territoryId}
                onChange={handleChange}
                value={nameFromState ?? item.name}
              />
            </li>
          )
        })}
      </ul>
      <div className="buttonsSection">
        <Button appearance="link" onClick={handleCancel}>
          <T keyName={TOLGEE_GLOBALS.cancel.key}>{TOLGEE_GLOBALS.cancel.defaultValue}</T>
        </Button>
        <Button onClick={handleViewConfirmation} disabled={isSubmitButtonDisabled}>
          <T keyName={TOLGEE_GLOBALS.confirm.key}>{TOLGEE_GLOBALS.confirm.defaultValue}</T>
        </Button>
      </div>
    </div>
  )
}
